import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import { caseEsito, daIso, GIORNI_BREVI, messaggioErrore } from '../../utils/agenda';
import { COLLABORAZIONI, DICHIARAZIONI, testoMancano } from '../../utils/scheda';
import { linkChiama, linkWhatsApp } from '../../utils/percorso';
import Icona from '../../components/cliente/Icone';
import EsitoTelefonata from '../../components/staff/EsitoTelefonata';
import CosaVoce from '../../components/staff/CosaVoce';
import Provvigione, { GENERICI, ROTTE, perche, soldi, tagStato } from '../../components/staff/Provvigione';
import { Logo } from './Agenzie';
import '../../components/staff/scheda.css';

// /admin/agenzie/:id: la scheda dell'agenzia, bozza design/admin-agenzie-v3.html. Logo grande, dichiarazione e
// collaborazione a menu, WhatsApp, Chiama, Esito telefonata; "Come lavora con noi" con il consiglio; immobili trattati;
// storico dei contatti; referenti, note interne, "Da fare con loro"; in fondo "Quanto ha fruttato" (le provvigioni con
// questa agenzia). Dati: GET /api/agenzie/{id}/scheda e GET /api/provvigioni/pratiche?agenzia={id}.

const NOTA = /^\[(\d{2}\/\d{2}\/\d{4})\s+([^\]]*)\]\s*(.*)$/;
export const noteDa = (testo) => {
  const note = []; const libere = [];
  String(testo || '').split('\n').forEach((r) => { const m = NOTA.exec(r.trim()); if (m) note.push({ testo: m[3], autore: m[2], data: m[1] }); else if (r.trim()) libere.push(r.trim()); });
  if (libere.length) note.unshift({ testo: libere.join(' ') });
  return note.reverse();
};

const giorno = (valore, conAnno = false) => {
  if (!valore) return '—';
  const d = new Date(valore);
  return `${d.getDate()} ${d.toLocaleDateString('it-IT', { month: 'short' })}${conAnno ? ` ${d.getFullYear()}` : ''}`;
};

// Referenti: nome, ruolo, telefono, email, nota, quando chiamarlo; WhatsApp e Chiama; + Aggiungi, Modifica, togli.
//
// **Basta un campo solo** (nome, o numero, o email): di un'agenzia spesso si ha solo il numero del centralino, e
// prima il nome era obbligatorio — chi non lo sapeva se lo inventava o non salvava niente. Il numero può anche
// essere una frase («centralino, int. 4»): il server la tiene com'è.
const CAMPI_REFERENTE = [['nome', 'Nome'], ['ruolo', 'Ruolo'], ['telefono', 'Telefono'], ['email', 'Email'],
  ['orari', 'Quando chiamarlo'], ['nota', 'Nota']];
const VUOTO = { nome: '', ruolo: '', telefono: '', email: '', orari: '', nota: '' };
// Come si chiama un referente quando il nome non c'è (stessa regola del server: scheda_agenzie.come_si_chiama)
export const nomeReferente = (r) => r?.nome || r?.telefono || r?.email || 'questo referente';

const Referenti = ({ agenzia, onFatto }) => {
  // `id` = quale referente si sta modificando (assente = se ne sta aggiungendo uno nuovo). **Non** la posizione
  // nell'elenco: se l'altro admin ne toglie uno mentre stiamo scrivendo, le posizioni scivolano e si finirebbe a
  // modificare il referente sbagliato.
  const [modulo, setModulo] = useState(null);  // {id?, nome, ruolo, telefono, email, orari, nota}
  const [togli, setTogli] = useState(null);
  const [errore, setErrore] = useState(null);
  // almeno una delle tre cose che identificano un referente: il resto è colore
  const bastante = modulo && [modulo.nome, modulo.telefono, modulo.email].some((v) => (v || '').trim());
  const salva = async (e) => {
    e.preventDefault();
    const { id, ...dati } = modulo;
    setErrore(null);
    try {
      if (id === undefined) await axios.post(`${API}/agenzie/${agenzia.id}/referenti`, dati);
      else await axios.put(`${API}/agenzie/${agenzia.id}/referenti/${id}`, dati);
      setModulo(null); onFatto();
    } catch (err) {
      // il messaggio si vede **dentro il modulo**, accanto ai campi: un avviso che scompare da solo, mentre si
      // guarda altrove, non dice a nessuno che il referente non è stato salvato
      const testo = messaggioErrore(err, 'Il referente non è stato salvato. Riprovate.');
      setErrore(testo);
      toast.error(testo);
    }
  };
  const conferma = async (r) => {
    try { await axios.delete(`${API}/agenzie/${agenzia.id}/referenti/${r.id}`); setTogli(null); onFatto(); }
    catch (err) { toast.error(messaggioErrore(err, 'Il referente non è stato tolto. Riprovate.')); }
  };
  return (
    <section className="card r" data-testid="referenti">
      <div className="ttl"><div className="i"><Icona nome="persone" /></div><h2>Referenti</h2>
        <button type="button" className="link" onClick={() => { setErrore(null); setModulo(modulo ? null : { ...VUOTO }); }}>+ Aggiungi</button></div>
      {modulo && (
        <form className="form-griglia" onSubmit={salva} style={{ marginBottom: '.8rem' }} data-testid="modulo-referente">
          {CAMPI_REFERENTE.map(([k, n]) => (
            <label key={k}>{n}
              <input value={modulo[k] || ''} type={k === 'email' ? 'email' : 'text'}
                onChange={(e) => setModulo({ ...modulo, [k]: e.target.value })} />
            </label>
          ))}
          <div style={{ alignSelf: 'end', display: 'flex', gap: '.4rem' }}>
            <button type="submit" className="btn sm p" disabled={!bastante}>Salva</button>
            <button type="button" className="btn sm" onClick={() => { setModulo(null); setErrore(null); }}>Annulla</button>
          </div>
          {!bastante && (
            <p className="muto" data-testid="referente-serve-qualcosa" style={{ gridColumn: '1 / -1', fontSize: '.74rem', margin: 0 }}>
              Scrivete almeno il nome, il numero o l'email: il resto è facoltativo.
            </p>
          )}
          {errore && (
            <p role="alert" data-testid="referente-errore" style={{ gridColumn: '1 / -1', fontSize: '.78rem', color: 'var(--bad)', margin: 0 }}>
              {errore}
            </p>
          )}
        </form>
      )}
      <div className="rows">
        {!agenzia.referenti.length && !modulo && <p className="vuoto">Nessun referente: aggiungete chi vi risponde.</p>}
        {agenzia.referenti.map((r) => {
          const wa = linkWhatsApp(r.telefono);
          const tel = linkChiama(r.telefono);
          return (
            <div key={r.id || r.indice} className="sotto" data-testid={`referente-${r.indice}`}>
              <div className="av">{(r.nome || r.telefono || r.email || '?').charAt(0)}</div>
              {/* senza nome la riga si intesta al numero o all'email: un referente senza nome esiste */}
              <div style={{ minWidth: 0 }}><b>{r.nome || r.telefono || r.email}</b>
                <span>{[r.ruolo, r.nome ? r.telefono : null, r.email, r.orari, r.nota].filter(Boolean).join(' · ')}</span>
              </div>
              <div className="azioni" style={{ flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                {togli === r.id ? (
                  <>
                    <span className="muto" style={{ fontSize: '.74rem' }}>Togliere {nomeReferente(r)}?</span>
                    <button type="button" className="btn sm rosso" onClick={() => conferma(r)}>Togli</button>
                    <button type="button" className="btn sm" onClick={() => setTogli(null)}>No</button>
                  </>
                ) : (
                  <>
                    {wa && <a className="btn sm wa" href={wa} target="_blank" rel="noopener noreferrer">WhatsApp</a>}
                    {tel && <a className="btn sm" href={tel}>Chiama</a>}
                    <button type="button" className="btn sm" onClick={() => { setErrore(null); setModulo({ ...VUOTO, id: r.id, nome: r.nome || '', ruolo: r.ruolo || '', telefono: r.telefono || '', email: r.email || '', orari: r.orari || '', nota: r.nota || '' }); }}
                      aria-label={`Modifica ${nomeReferente(r)}`}>Modifica</button>
                    <button type="button" className="x" onClick={() => setTogli(r.id)} aria-label={`Togli ${nomeReferente(r)}`}>✕</button>
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

// "Quanto ha fruttato": in fondo alla scheda, il totale delle provvigioni con questa agenzia (previsto, fatturato,
// incassato, e quanto ci ha riconosciuto lei) e le pratiche una per una; da ogni riga si apre la stessa provvigione
// che si compila dalla proposta accettata. Sono soldi: sta solo qui, nelle pagine dello staff, e i conti sono quelli
// del server: il totale viene dalla rotta fatta apposta per le agenzie (GET /api/provvigioni/agenzie), un conto solo
// fatto in un posto solo, e da qui si prende la riga di questa agenzia; l'elenco delle pratiche viene invece da
// GET /api/provvigioni/pratiche?agenzia={id}. Un'agenzia senza pratiche non ha riga: il totale resta a zero.
const QUANTO = [['previsto', 'previsto'], ['fatturato', 'fatturato'], ['incassato', 'incassato'], ['da_agenzia', "dall'agenzia"]];
const PROBLEMI_AGENZIA = {
  ...GENERICI,
  403: 'Le provvigioni delle agenzie le vede solo chi si occupa dei conti.',
  404: 'Non trovo le provvigioni di questa agenzia: le provvigioni non sono ancora collegate al server.',
  errore: 'Non riesco a caricare quanto ha fruttato questa agenzia.',
};

// Il totale di QUESTA agenzia dentro la risposta della rotta delle agenzie: senza pratiche la riga non c'è
export const totaleDiAgenzia = (risposta, agenziaId) => (risposta?.agenzie || []).find((a) => a.agenzia_id === agenziaId) || null;

const QuantoHaFruttato = ({ agenziaId }) => {
  const [dati, setDati] = useState(null);
  const [problema, setProblema] = useState(null);
  const [versione, setVersione] = useState(0);
  useEffect(() => {
    let vivo = true;
    Promise.all([axios.get(`${API}${ROTTE.agenzie}`), axios.get(`${API}${ROTTE.pratiche}`, { params: { agenzia: agenziaId } })])
      .then(([ag, pr]) => {
        if (!vivo) return;
        // Una rotta che non c'è ancora, in locale, torna la pagina del sito: meglio dirlo che mostrare zeri finti
        if (!pr.data || !Array.isArray(pr.data.pratiche) || !ag.data || !Array.isArray(ag.data.agenzie)) {
          setProblema(PROBLEMI_AGENZIA.vuoto); return;
        }
        setDati({ pratiche: pr.data.pratiche, totale: totaleDiAgenzia(ag.data, agenziaId) });
      })
      .catch((e) => { if (vivo) setProblema(perche(e, PROBLEMI_AGENZIA)); });
    return () => { vivo = false; };
  }, [agenziaId, versione]);
  const totale = dati?.totale || {};
  const pratiche = dati?.pratiche || [];
  return (
    <section className="card r" data-testid="quanto-ha-fruttato" style={{ marginTop: '1rem' }}>
      <div className="ttl"><div className="i"><Icona nome="euro" /></div><h2>Quanto ha fruttato</h2>
        {totale.pratiche !== undefined && <small>{totale.pratiche} {totale.pratiche === 1 ? 'pratica' : 'pratiche'}</small>}</div>
      {problema && <p className="vuoto" data-testid="provvigioni-problema">{problema}</p>}
      {!problema && !dati && <p className="vuoto">Carico le provvigioni dell'agenzia…</p>}
      {dati && (
        <>
          <div className="kv kv4">
            {QUANTO.filter(([k]) => totale[k] !== undefined && totale[k] !== null).map(([k, nome]) => (
              <div key={k}><small>{nome}</small><b className={k === 'incassato' ? 'g' : undefined}>{soldi(totale[k])}</b></div>
            ))}
          </div>
          <div className="prov-pratiche" style={{ marginTop: '.9rem' }}>
            {!pratiche.length && <p className="vuoto">Con questa agenzia non c'è ancora nessuna pratica.</p>}
            {pratiche.map((p) => {
              const stato = tagStato(p.stato);
              return (
                <div key={p.proposta_id} data-testid={`pratica-${p.proposta_id}`}>
                  <div className="capo">
                    <b>{p.cliente || 'cliente'}</b>
                    <small>{[p.immobile, giorno(p.data)].filter(Boolean).join(' · ')}</small>
                    {p.c_e ? <span className={`tag ${stato[0]}`}>{stato[1]}</span> : <span className="muto" style={{ fontSize: '.74rem' }}>da compilare</span>}
                    <span className="cifra">{p.conti ? soldi(p.conti.incasso_lordo) : '—'}</span>
                    {p.cliente_id && <Link className="btn sm" to={`/admin/clienti/${p.cliente_id}#proposte`}>Cliente</Link>}
                  </div>
                  <Provvigione propostaId={p.proposta_id} apribile onCambiata={() => setVersione((x) => x + 1)} />
                </div>
              );
            })}
          </div>
        </>
      )}
    </section>
  );
};

const RigaDaFare = ({ v, agenzia, onFatto }) => {
  const [esito, setEsito] = useState(false);
  const d = v.data ? daIso(v.data) : null;
  return (
    <div>
      <div className="av" style={{ fontSize: '.7rem' }}>{d ? GIORNI_BREVI[d.getDay()] : '—'}</div>
      <div style={{ minWidth: 0 }}>{v.cosa ? <CosaVoce cosa={v.cosa} tipo={v.tipo} voce={v} /> : <b>{v.titolo}</b>}
        <span>{[v.cosa ? null : v.cliente_breve, d ? `${d.getDate()}/${d.getMonth() + 1}${v.ora ? ` ${v.ora}` : ''}` : 'da mettere in agenda'].filter(Boolean).join(' · ')}</span></div>
      {v.tipo === 'telefonata' ? <button type="button" className="btn sm p" onClick={() => setEsito(!esito)}>{v.data ? 'Esito' : 'Fissa'}</button>
        : v.immobile_id ? <Link className="btn sm" to={`/immobili/${v.immobile_id}`}>Apri</Link> : <span />}
      {/* telefonata raggruppata: l'esito si dà per tutte le case insieme, come in Oggi e in agenda */}
      {esito && <div style={{ gridColumn: '1/-1' }}><EsitoTelefonata voce={{ ...v, agenzia_id: agenzia.id }} case={caseEsito(v)}
        nomeAgenzia={agenzia.etichetta || agenzia.nome} nomeCliente={v.cliente_breve} onFatto={() => { setEsito(false); onFatto(); }} /></div>}
    </div>
  );
};

const SchedaAgenzia = () => {
  const { id } = useParams();
  const [a, setA] = useState(null);
  const [esito, setEsito] = useState(false);
  const [nota, setNota] = useState(null);
  const [versione, setVersione] = useState(0);
  const ricarica = useCallback(() => setVersione((x) => x + 1), []);
  // I due casi si tengono separati, come nella scheda del cliente e in quella dell'immobile: un 500 o la rete
  // caduta NON vogliono dire che l'agenzia non c'è. Prima finiva tutto in «Agenzia non trovata» e si andava a
  // cercare un'agenzia che sta benissimo (blocco 4, primo giro).
  useEffect(() => {
    axios.get(`${API}/agenzie/${id}/scheda`).then((r) => setA(r.data))
      .catch((e) => setA(e.response?.status === 404 ? false : 'errore'));
  }, [id, versione]);
  if (a === false) return <main className="st wrap"><p className="vuoto">Agenzia non trovata: forse è stata unita a un&apos;altra (Agenzie → Possibili doppioni).</p></main>;
  if (a === 'errore') {
    return (
      <main className="st wrap">
        <p className="vuoto" role="status">Non riesco a caricare l&apos;agenzia. Riprovate tra poco.</p>
        <p className="vuoto"><button type="button" className="btn sm" onClick={ricarica} data-testid="agenzia-riprova">Riprovate</button></p>
      </main>
    );
  }
  if (!a) return <main className="st wrap"><p className="vuoto">Carico l&apos;agenzia…</p></main>;
  const cambia = async (url, corpo) => {
    try { await axios.put(`${API}/agenzie/${id}/${url}`, corpo); toast.success('Fatto'); ricarica(); } catch { toast.error('Non riuscito'); }
  };
  const salvaNota = async () => {
    if (!nota?.trim()) return;
    try { await axios.post(`${API}/agenzie/${id}/note`, { testo: nota }); setNota(null); ricarica(); } catch { toast.error('Non riuscito'); }
  };
  const d = DICHIARAZIONI[a.dichiarazione] || DICHIARAZIONI.in_attesa_dichiarazione;
  const col = COLLABORAZIONI[a.collaborazione] || COLLABORAZIONI.in_attesa;
  const w = a.come_lavora;
  const tel = linkChiama(a.telefono);
  const wa = linkWhatsApp(a.referenti.find((r) => r.telefono)?.telefono || a.telefono);
  const portali = Object.keys(a.url_portale || {});
  const note = noteDa(a.note);
  return (
    <main className="st wrap" data-testid="scheda-agenzia">
      <Link className="back" to="/admin/agenzie"><Icona nome="indietro" />Agenzie</Link>
      <div className="ah r">
        <Logo a={a} />
        <div style={{ minWidth: 0 }}>
          <h1>{a.nome}</h1>
          <div className="meta">
            {(a.comune || a.indirizzo) && <span>{[a.comune, a.indirizzo].filter(Boolean).join(' · ')}</span>}
            {a.telefono && <a href={tel || '#'}>{a.telefono}</a>}
            {a.email && <a href={`mailto:${a.email}`}>{a.email}</a>}
            {portali.length > 0 && <span>{portali.map((p) => <a key={p} href={a.url_portale[p]} target="_blank" rel="noopener noreferrer" style={{ marginRight: '.4rem' }}>{p}</a>)}</span>}
            <span>marchio: {a.marchio || 'indipendente'}</span>
            <span className={`dich ${d.classe}`} style={{ marginTop: 0 }} data-testid="dichiarazione">{d.testo}{a.data_dichiarazione ? ` · ${giorno(a.data_dichiarazione, true)}` : ''}</span>
            {/* agenzia che vende aste giudiziarie: le sue case non entrano in nessuna proposta (backend/aste.py) */}
            {a.aste && (
              <span className="tag t-r" data-testid="agenzia-aste" title={a.aste_perche ? `Riconosciuta da: ${a.aste_perche}` : undefined}>
                Aste
              </span>
            )}
          </div>
          {(a.mancano || []).length > 0 && <p className="mancano" style={{ fontSize: '.78rem', marginTop: '.3rem' }}>{testoMancano(a.mancano)}{a.completamento?.stato ? ` · completamento automatico: ${a.completamento.stato.replace('_', ' ')}` : ''}</p>}
        </div>
        <div className="acts">
          <span className="sel"><i style={{ background: col.colore }} />
            <select value={a.collaborazione} onChange={(e) => cambia('collaborazione', { stato_verifica: e.target.value })} aria-label="Collaborazione">
              {Object.entries(COLLABORAZIONI).map(([k, v]) => <option key={k} value={k}>{v.testo}</option>)}
            </select>▾</span>
          <span className="menu-dich">
            <span className="sel"><i style={{ background: d.colore }} />
              <select value={a.dichiarazione} onChange={(e) => cambia('dichiarazione', { stato_dichiarato: e.target.value })} aria-label="Dichiarazione">
                {Object.entries(DICHIARAZIONI).map(([k, v]) => <option key={k} value={k}>{v.testo}</option>)}
              </select>▾</span>
            <small>{a.data_dichiarazione ? `dal ${giorno(a.data_dichiarazione, true)}` : 'data non segnata'}</small>
          </span>
          {wa && <a className="btn wa" href={wa} target="_blank" rel="noopener noreferrer"><Icona nome="whatsapp" />WhatsApp</a>}
          {tel && <a className="btn" href={tel}>Chiama</a>}
          <button type="button" className="btn p" onClick={() => setEsito(!esito)}>Esito telefonata</button>
          <Link className="btn sm" to={`/admin/agenzie/${id}/modifica`}>Modifica</Link>
        </div>
      </div>
      {esito && <div className="card" style={{ marginBottom: '1rem' }}><EsitoTelefonata voce={{ id: `agenzia:${id}`, tipo: 'telefonata', agenzia_id: id, tentativi: 0 }} onFatto={() => { setEsito(false); ricarica(); }} /></div>}

      <div className="g2">
        <div className="stack">
          <section className="card hero r" data-testid="come-lavora">
            <div className="ttl"><div className="i"><Icona nome="stella" /></div><h2>Come lavora con noi</h2></div>
            <div className="kv kv4">
              <div><small>Immobili</small><b>{w.immobili}</b></div>
              <div><small>Visite fatte</small><b className={w.visite_fatte ? 'g' : undefined}>{w.visite_fatte}</b></div>
              <div><small>Proposte</small><b>{w.proposte}</b></div>
              <div><small>Rogiti</small><b>{w.rogiti}</b></div>
              <div><small>Risponde in</small><b className={w.risponde_in ? 'g' : 'vuoto'}>{w.risponde_in || '—'}</b></div>
              <div><small>Telefonate a vuoto</small><b className={w.telefonate && w.a_vuoto > w.telefonate / 2 ? 'no' : w.telefonate ? undefined : 'vuoto'}>{w.telefonate ? `${w.a_vuoto} su ${w.telefonate}` : '—'}</b></div>
              <div><small>Visite / richieste</small><b>{w.richieste_totali ? `${w.visite} su ${w.richieste_totali}` : '—'}</b></div>
              <div><small>Ultimo contatto</small><b>{giorno(w.ultimo_contatto)}</b></div>
            </div>
            {a.consiglio && <div className="tip consiglio-agenzia" data-testid="consiglio-agenzia"><Icona nome="stella" /><div>{a.consiglio}</div></div>}
          </section>
          <section className="card r">
            <div className="ttl"><div className="i b"><Icona nome="immobili" /></div><h2>Immobili <small>{a.immobili.length} · {a.immobili.filter((i) => i.stato_attivita !== 'scartato').length} attivi</small></h2></div>
            <div className="rows">
              {!a.immobili.length && <p className="vuoto">Nessun immobile trattato con loro.</p>}
              {a.immobili.map((i) => (
                <div key={i.id}>
                  {i.foto ? <img className="im" src={i.foto} alt="" /> : <div className="im" />}
                  <div style={{ minWidth: 0 }}><b>{i.titolo || i.indirizzo}</b><span>{[i.cliente, i.stato_testo].filter(Boolean).join(' · ')}</span></div>
                  <Link className={`btn sm${i.visita_richiesta ? ' p' : ''}`} to={i.visita_richiesta ? `/admin/clienti/${i.cliente_id}#visite` : `/immobili/${i.id}`}>{i.visita_richiesta ? 'Fissa' : 'Apri'}</Link>
                </div>
              ))}
            </div>
          </section>
          {/* Chi ha più di una casa con loro si chiama una volta sola per tutte (backend/agenzia_case.py) */}
          {(a.clienti_piu_case || []).length > 0 && (
            <section className="card r" data-testid="clienti-piu-case">
              <div className="ttl"><div className="i b"><Icona nome="persone" /></div>
                <h2>Clienti con più case qui <small>una telefonata sola per tutte</small></h2></div>
              <div className="rows">
                {a.clienti_piu_case.map((r) => (
                  <div key={r.cliente_id} data-testid={`piu-case-${r.cliente_id}`}>
                    <div style={{ minWidth: 0 }}>
                      <b>{r.cliente} · {r.attive} case</b>
                      <span>{r.case.map((c) => c.indirizzo || c.titolo).join(' · ')}</span>
                    </div>
                    <Link className="btn sm p" to={`/admin/clienti/${r.cliente_id}#immobili`}>Apri</Link>
                  </div>
                ))}
              </div>
            </section>
          )}
          <section className="card r">
            <div className="ttl"><div className="i"><Icona nome="orologio" /></div><h2>Storico dei contatti</h2></div>
            <div className="feed">
              {!a.storico.length && <p className="vuoto">Ancora nessun contatto registrato.</p>}
              {a.storico.slice(0, 20).map((s) => (
                <div key={s.id}><i className={`dot ${['non_rispondono', 'attesa_disponibilita'].includes(s.esito) ? 'w' : s.esito ? 'g' : 'k'}`} /><div style={{ minWidth: 0 }}><b>{s.testo}</b><span>{[giorno(s.data), s.autore].filter(Boolean).join(' · ')}</span></div></div>
              ))}
            </div>
          </section>
        </div>
        <div className="stack">
          <Referenti agenzia={a} onFatto={ricarica} />
          <section className="card r">
            <div className="ttl"><div className="i"><Icona nome="documento" /></div><h2>Note interne</h2><button type="button" className="link" onClick={() => setNota(nota === null ? '' : null)}>+ Nota</button></div>
            {nota !== null && <div className="campo-nota" style={{ marginBottom: '.6rem' }}><textarea value={nota} onChange={(e) => setNota(e.target.value)} rows={2} aria-label="Nuova nota" autoFocus /><button type="button" className="btn sm p" onClick={salvaNota}>Salva</button></div>}
            {!note.length && nota === null && <p className="vuoto">Nessuna nota.</p>}
            {note.slice(0, 5).map((n, i) => <div className="note" key={i}>{n.testo}{n.autore && <small>{n.autore} · {n.data}</small>}</div>)}
          </section>
          <section className="card r">
            <div className="ttl"><div className="i w"><Icona nome="calendario" /></div><h2>Da fare con loro</h2></div>
            <div className="rows">
              {!a.da_fare.length && <p className="vuoto">Niente in sospeso con questa agenzia.</p>}
              {a.da_fare.map((v) => <RigaDaFare key={v.id} v={v} agenzia={a} onFatto={ricarica} />)}
            </div>
          </section>
        </div>
      </div>
      <QuantoHaFruttato agenziaId={id} />
    </main>
  );
};

export default SchedaAgenzia;
